export default __webpack_public_path__ + "static/media/campuswire-ss.56506b9f.png";